// @ts-nocheck
/* eslint-disable */
export const boldUserIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" d="M9 9a3.75 3.75 0 1 0 0-7.5A3.75 3.75 0 0 0 9 9m0 1.875c-3.757 0-6.817 2.52-6.817 5.625 0 .21.165.375.375.375h12.885c.21 0 .375-.165.375-.375 0-3.105-3.06-5.625-6.818-5.625"/></svg>`,
    name: 'bold-user' as const
};